<div class="item-freetext">
  <rotec-text-input-v2
    [(value)]="item.value"
    placeholder="This is a Text"
    max="60"
    class="input"
    [class.text-bold]="active"
  ></rotec-text-input-v2>
  <rotec-toggle-button-v2
    [active]="active"
    (activeChange)="toggleStatusChanged($event)"
    icon="bold"
  >
  </rotec-toggle-button-v2>
  <button
    rotec-button-primary-v2
    (click)="deleteItem(item)"
    icon="trash"
    class="button button-trash"
  ></button>
</div>
